export default "__VITE_ASSET__CvEBT_kE__"